<template>
    <div class="w-full animate-pulse bg-white p-4 rounded-lg shadow-md flex gap-4">
        <div class="flex-1 space-y-3 py-1">
            <div class="h-4 bg-gray-200 rounded w-3/4"></div>
            <div class="space-y-2">
                <div class="h-4 bg-gray-200 rounded"></div>
                <div class="h-4 bg-gray-200 rounded w-5/6"></div>
            </div>
        </div>
        <div class="h-24 w-24 bg-gray-200 rounded-md"></div>
    </div>
</template>
